import React from 'react';
import PropTypes from 'prop-types';

import EmptyIcon from '../EmptyIcon';
import './EmptyState.scss';

const EmptyState = ({ text, children }) => (
  <div className="empty-state-wrapper">
    <div className="icon-wrapper">
      <EmptyIcon />
    </div>

    <div className="text-wrapper">{text}</div>
    <div className="empty-content-wrapper">{children}</div>
  </div>
);

EmptyState.defaultProps = {
  children: null,
};

EmptyState.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.node,
};

export default EmptyState;
